
import Vue from "vue";
import HeroBar from "@/components/HeroBar.vue";
export default Vue.extend({
  name: "RequestAccess",
  components: {
    HeroBar
  }
});
